export default __webpack_public_path__ + "81e698406e0d28a7a0dd4423c565c574.png";